import { make } from 'vuex-pathify';
import { filter, keyBy, keys, sortBy, values } from 'lodash';

const relationships = keyBy(
    [
        {
            id: 1,
            text: 'Boo',
            answer: '',
            other: ''
        },
        {
            id: 2,
            text: 'One Night Stand',
            answer: '',
            other: ''
        },
        {
            id: 3,
            text: 'Client',
            answer: '',
            other: ''
        }
    ],
    'id'
);
const relationshipsOrder = sortBy(keys(relationships), k => parseInt(k));
const choices = [
    'I’ll always make sure we’re using a condom',
    'We won’t use condoms and my partner will pull out before they cum',
    'We won’t use condoms and my partner will cum inside me',
    'I am not ready to do this, but I am totally open to blow jobs',
    'I’ll never do this (bottoming)'
];

const state = {
    title: 'Boundaries',
    complete: false,
    sticker: {
        text: 'Girl with arms crossed in an X emoji',
        earned: false,
        image: require('@/assets/stickers/stickers_0012_girlx.png')
    },
    bonusSticker: false,
    trophy: false,
    relationships,
    relationshipsOrder,
    choices
};
const getters = {
    ...make.getters(state),
    numRelationshipsAnswered: state => {
        return filter(values(state.relationships), val => val.answer !== '').length;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
